import { Routes } from '@angular/router';
import { OnboardingGuard } from './guards/onboarding/onboarding.guard';
import {
  ACCOUNT_SETTINGS,
  AD_REWARD_INFO,
  AUTH,
  BRONZE_BENEFITS,
  CHANGE_PASSWORD,
  CHARACTER,
  CONFLICT,
  EMAIL_TO_VERIFY_MODAL,
  FORGOT_PASSWORD,
  GENRE,
  GENRE_SELECTION,
  LANDING_SCREEN,
  LOADING_SCREEN,
  PLOT,
  PRIVACY,
  PROFILE_AGE,
  PROFILE_CREATE,
  PROFILE_CUSTOMIZATION,
  PROFILE_GET_READY,
  PROFILE_EDIT,
  PROFILE_LANGUAGE,
  PROFILE_NARRATOR,
  PROFILE_SETTINGS,
  RATING_1,
  RATING_2,
  SETTING,
  SIGN_IN,
  SIGN_UP,
  STORY_CUSTOMIZATION,
  STORY_OPTIONS,
  STORY_PLAYER,
  STORY_PLAYER_WEB,
  TERMS,
  THEME,
  TONE,
  TOS_PRIVACY_AGREEMENT,
  TROPHIES_JOURNEY,
  TROPHIES_TAB,
  VOICE_CLONE_CUSTOM_VOICE,
  VOICE_CLONE_OVERVIEW,
  VOICE_CLONE_CREATE_VOICE,
  VOICE_CLONE_LOADING,
  VOICE_CLONE_MODIFY_VOICE,
  VOICE_CLONE_REQUEST_VOICE,
  VOICE_CLONE_RECORD,
  VOICE_CLONE_VOICES,
  VOICE_CLONE_WEB_CLONE_SUCCESS,
  VOICE_CLONE_WEB_WELCOME,
  WELCOME_SCREEN_1,
  WELCOME_SCREEN_2,
  WELCOME_SCREEN_3,
  WELCOME_SCREEN_4,
  WELCOME_SCREEN_PAYWALL,
  WELCOME_SCREEN_DECLINE_OFFER_1,
  WELCOME_SCREEN_AGE,
  WORD_OF_THE_DAY,
} from '@storees/shared-constants';

const tabsLoadChildren = () => import('./tabs/tabs.routes').then((m) => m.routes);

export const routes: Routes = [
  {
    path: '',
    loadChildren: tabsLoadChildren,
  },
  {
    path: WELCOME_SCREEN_1,
    loadComponent: () => import('./welcome/components/welcome-screen-1/welcome-screen-1.component')
      .then((c) => c.WelcomeScreen1Component)
  },
  {
    path: WELCOME_SCREEN_2,
    loadComponent: () => import('./welcome/components/welcome-screen-2/welcome-screen-2.component')
      .then((c) => c.WelcomeScreen2Component)
  },
  {
    path: WELCOME_SCREEN_3,
    loadComponent: () => import('./welcome/components/welcome-screen-3/welcome-screen-3.component')
      .then((c) => c.WelcomeScreen3Component)
  },
  {
    path: WELCOME_SCREEN_4,
    loadComponent: () => import('./welcome/components/welcome-screen-4/welcome-screen-4.component')
      .then((c) => c.WelcomeScreen4Component)
  },
  {
    path: WELCOME_SCREEN_PAYWALL,
    loadComponent: () => import('./welcome/components/welcome-screen-paywall/welcome-screen-paywall.component')
      .then((c) => c.WelcomeScreenPaywallComponent)
  },
  {
    path: WELCOME_SCREEN_DECLINE_OFFER_1,
    loadComponent: () => import('./welcome/components/welcome-screen-decline-offer-1/welcome-screen-decline-offer-1.component')
      .then((c) => c.WelcomeScreenDeclineOffer1Component)
  },
  {
    path: WELCOME_SCREEN_AGE,
    loadComponent: () => import('./welcome/components/welcome-screen-age/welcome-screen-age.component')
      .then((c) => c.WelcomeScreenAgeComponent)
  },
  {
    path: TOS_PRIVACY_AGREEMENT,
    loadComponent: () => import('./welcome/components/tos-privacy-agreement/tos-privacy-agreement.component')
      .then((c) => c.TosPrivacyAgreementComponent)
  },
  {
    path: TERMS,
    loadComponent: () => import('./welcome/components/terms/terms.component')
      .then((c) => c.TermsComponent)
  },
  {
    path: PRIVACY,
    loadComponent: () => import('./welcome/components/privacy/privacy.component')
      .then((c) => c.PrivacyComponent)
  },
  {
    path: RATING_1,
    loadComponent: () => import('./components/rating/rating-1/rating-1.component')
      .then((c) => c.Rating1Component)
  },
  {
    path: RATING_2,
    loadComponent: () => import('./components/rating/rating-2/rating-2.component')
      .then((c) => c.Rating2Component)
  },
  {
    path: GENRE,
    loadComponent: () => import('./story-home/components/genre/genre.component')
      .then((c) => c.GenreComponent)
  },
  {
    path: SETTING,
    loadComponent: () => import('./story-home/components/setting/setting.component').then(m => m.SettingComponent),
  },
  {
    path: THEME,
    loadComponent: () => import('./story-home/components/theme/theme.component').then(m => m.ThemeComponent)
  },
  {
    path: CHARACTER,
    loadComponent: () => import('./story-home/components/character/character.component').then(m => m.CharacterComponent)
  },
  {
    path: CONFLICT,
    loadComponent: () => import('./story-home/components/conflict/conflict.component').then(m => m.ConflictComponent)
  },
  {
    path: PLOT,
    loadComponent: () => import('./story-home/components/plot/plot.component').then(m => m.PlotComponent),
  },
  {
    path: TONE,
    loadComponent: () => import('./story-home/components/tone/tone.component').then(m => m.ToneComponent)
  },
  {
    path: WORD_OF_THE_DAY,
    loadComponent: () => import('./story-home/components/word-of-the-day/word-of-the-day.component').then(m => m.WordOfTheDayComponent)
  },
  {
    path: GENRE_SELECTION,
    loadComponent: () => import('./story-home/components/genre-selection/genre-selection.component')
      .then((c) => c.GenreSelectionComponent),
  },
  {
    path: STORY_OPTIONS,
    loadComponent: () => import('./story-home/components/story-options/story-options.component')
      .then((c) => c.StoryOptionsComponent),
  },
  {
    path: STORY_CUSTOMIZATION,
    loadComponent: () => import('./story-home/components/story-customization/story-customization.component')
      .then((c) => c.StoryCustomizationComponent),
  },
  {
    path: LOADING_SCREEN,
    loadComponent: () => import('./story-home/components/loading-screen/loading-screen.component')
      .then((c) => c.LoadingScreenComponent),
  },
  {
    path: STORY_PLAYER,
    loadComponent: () => import('./story-home/components/story-player/story-player.component')
      .then((c) => c.StoryPlayerComponent),
  },
  {
    path: STORY_PLAYER_WEB,
    loadComponent: () => import('./story-home/components/story-player/story-player.component')
      .then((c) => c.StoryPlayerComponent),
  },
  {
    path: LANDING_SCREEN,
    canActivate: [OnboardingGuard], // Apply guard at this level
    loadComponent: () => import('./components/landing/landing-screen/landing-screen.component')
      .then((c) => c.LandingScreenComponent),
  },
  {
    path: BRONZE_BENEFITS,
    loadComponent: () => import('./components/bronze-benefits/bronze-benefits.component')
      .then((c) => c.BronzeBenefitsComponent),
  },
  {
    path: AD_REWARD_INFO,
    loadComponent: () => import('./components/ad-reward-info/ad-reward-info.component')
      .then((c) => c.AdRewardInfoComponent),
  },
  {
    path: PROFILE_CREATE,
    loadComponent: () => import('./components/profile/profile-create/profile-create.component')
      .then((c) => c.ProfileCreateComponent),
  },
  {
    path: PROFILE_AGE,
    loadComponent: () => import('./components/profile/profile-age/profile-age.component')
      .then((c) => c.ProfileAgeComponent),
  },
  {
    path: PROFILE_CUSTOMIZATION,
    loadComponent: () => import('./components/profile/profile-customization/profile-customization.component')
      .then((c) => c.ProfileCustomizationComponent),
  },
  {
    path: PROFILE_GET_READY,
    loadComponent: () => import('./components/profile/profile-get-ready/profile-get-ready.component')
      .then((c) => c.ProfileGetReadyComponent),
  },
  {
    path: PROFILE_LANGUAGE,
    loadComponent: () => import('./components/profile/profile-language/profile-language.component')
      .then((c) => c.ProfileLanguageComponent),
  },
  {
    path: PROFILE_NARRATOR,
    loadComponent: () => import('./components/profile/profile-narrator/profile-narrator.component')
      .then((c) => c.ProfileNarratorComponent),
  },
  {
    path: PROFILE_SETTINGS,
    loadComponent: () => import('./components/profile/profile-settings/profile-settings.component')
      .then((c) => c.ProfileSettingsComponent),
  },
  {
    path: PROFILE_EDIT,
    loadComponent: () => import('./components/profile/profile-edit/profile-edit.component')
      .then((c) => c.ProfileEditComponent),
  },
  {
    path: ACCOUNT_SETTINGS,
    loadComponent: () => import('./components/account-settings/account-settings.component')
      .then((c) => c.AccountSettingsComponent),
  },
  {
    path: TROPHIES_TAB,
    loadComponent: () => import('./trophies-tab/trophies-tab.component')
      .then((c) => c.TrophiesTabComponent),
  },
  {
    path: `${TROPHIES_JOURNEY}/:trophyId`,
    loadComponent: () => import('./trophies-tab/trophies-journey/trophies-journey.component')
      .then((c) => c.TrophiesJourneyComponent),
  },
  {
    path: AUTH,
    loadComponent: () => import('./components/auth/auth.component')
      .then((c) => c.AuthComponent),
  },
  {
    path: SIGN_IN,
    loadComponent: () => import('./components/auth/sign-in/sign-in.component')
      .then((c) => c.SignInComponent),
  },
  {
    path: SIGN_UP,
    loadComponent: () => import('./components/auth/sign-up/sign-up.component')
      .then((c) => c.SignUpComponent),
  },
  {
    path: EMAIL_TO_VERIFY_MODAL,
    loadComponent: () => import('./components/auth/email-to-verify-modal/email-to-verify-modal.component')
      .then((c) => c.EmailToVerifyModalComponent),
  },
  {
    path: CHANGE_PASSWORD,
    loadComponent: () => import('./components/auth/change-password/change-password.component')
      .then((c) => c.ChangePasswordComponent),
  },
  {
    path: FORGOT_PASSWORD,
    loadComponent: () => import('./components/auth/forgot-password/forgot-password.component')
      .then((c) => c.ForgotPasswordComponent),
  },
  {
    path: VOICE_CLONE_OVERVIEW,
    loadComponent: () => import('./components/voice-clone/voice-clone-overview/voice-clone-overview.component')
      .then((c) => c.VoiceCloneOverviewComponent),
  },
  {
    path: VOICE_CLONE_WEB_WELCOME,
    loadComponent: () => import('./components/voice-clone/voice-clone-web-welcome/voice-clone-web-welcome.component')
      .then((c) => c.VoiceCloneWebWelcomeComponent),
  },
  {
    path: VOICE_CLONE_VOICES,
    loadComponent: () => import('./components/voice-clone/voice-clone-voices/voice-clone-voices.component')
      .then((c) => c.VoiceCloneVoicesComponent),
  },
  {
    path: VOICE_CLONE_CUSTOM_VOICE,
    loadComponent: () => import('./components/voice-clone/voice-clone-custom-voice/voice-clone-custom-voice.component')
      .then((c) => c.VoiceCloneCustomVoiceComponent),
  },
  {
    path: VOICE_CLONE_RECORD,
    loadComponent: () => import('./components/voice-clone/voice-clone-record/voice-clone-record.component')
      .then((c) => c.VoiceCloneRecordComponent),
  },
  {
    path: VOICE_CLONE_CREATE_VOICE,
    loadComponent: () => import('./components/voice-clone/voice-clone-create-voice/voice-clone-create-voice.component')
      .then((c) => c.VoiceCloneCreateVoiceComponent),
  },
  {
    path: VOICE_CLONE_LOADING,
    loadComponent: () => import('./components/voice-clone/voice-clone-loading/voice-clone-loading.component')
      .then((c) => c.VoiceCloneLoadingComponent),
  },
  {
    path: VOICE_CLONE_MODIFY_VOICE,
    loadComponent: () => import('./components/voice-clone/voice-clone-modify-voice/voice-clone-modify-voice.component')
      .then((c) => c.VoiceCloneModifyVoiceComponent),
  },
  {
    path: VOICE_CLONE_REQUEST_VOICE,
    loadComponent: () => import('./components/voice-clone/voice-clone-request-voice/voice-clone-request-voice.component')
      .then((c) => c.VoiceCloneRequestVoiceComponent),
  },
  {
    path: VOICE_CLONE_WEB_CLONE_SUCCESS,
    loadComponent: () => import('./components/voice-clone/voice-clone-web-clone-success/voice-clone-web-clone-success.component')
      .then((c) => c.VoiceCloneWebCloneSuccessComponent),
  },
  // Angular router selects this route any time the requested URL doesn't match any router paths
  { path: '**', loadChildren: tabsLoadChildren }
];
